import {TCData} from "./model/t-c-data";
import cmpConfig from "../cmp-config";
import cmp from "../context/context";
import {log} from "../util/log";
import {ConsentData} from "./model/consent-data";

interface IListener {
    id: number;
    enabled: boolean;
    callback: Function;
}

interface IEventListeners {
    [eventName: string]: IListener[];
}

let counter: number = 1000;
let events: IEventListeners = {};

class EventManager {

    public static EVENT_CMP_GENERIC: string     = 'generic';
    public static EVENT_CMP_READY: string       = 'cmpReady';
    public static EVENT_CMP_LOADED: string      = 'isLoaded';
    public static EVENT_CMP_SUBMIT: string      = 'onSubmit';
    public static EVENT_CMP_CONFIGURED: string  = 'isConfigured';
    public static EVENT_CHANGED_CONFIG: string  = 'changedConfiguration';
    public static EVENT_CMP_UI: string          = 'ui';
    public static EVENT_CMP_ANALYTIC: string    = 'analytic';

    public static trigger(eventName: string, data?: any) : void {
        // Recurrentes
        const listeners: IListener[] = events[eventName] || [];
        listeners
            .filter((listener: IListener) => {return listener.enabled;})
            .forEach((listener: IListener) => {
                if (data) {
                    listener.callback(data);
                } else {
                    if (eventName == EventManager.EVENT_CMP_GENERIC) {
                        const tcData: TCData = TCData.build(!cmpConfig.gdprApplies ? [] : cmp().vendorList?.vendorIds());
                        tcData.listenerId = listener.id;
                        listener.callback(tcData, true);
                    } else {
                        const consentData: ConsentData = ConsentData.build(listener.id);
                        listener.callback(consentData, true);
                    }
                }
        });

        if (listeners.length) {
            log.debug(`Event triggered: ${eventName}`);
            log.debug('', listeners);
        }
    }

    public static registerEvent(eventName:string, callback:Function) : number {
        const eventMap:IEventListeners = events;
        // Generamos id único
        const listenerId:number = ++counter;
        if (!eventMap[eventName]) {
            eventMap[eventName] = [];
        }
        eventMap[eventName].push({
            id: listenerId,
            enabled: true,
            callback: callback
        });

        log.debug(`Event registered: ${eventName}. Listener ID: ${listenerId}`);
        log.debug('', eventMap);

        return listenerId;
    }

    public static unsubscribe(listenerId: number) : boolean {
        let findListenerId:boolean = false;
        Object.keys(events).forEach((eventName:string) => {
            const idx:number = events[eventName].findIndex((listener:IListener) => {
                return listener.id == listenerId;
            });
            if (idx >= 0) {
                events[eventName][idx].enabled = false;
                findListenerId = true;
            }
        });
        return findListenerId;
    }

    public static resetListeners(): void {
        events = {};
    }
}

export {EventManager}
